<template>
  <li class="list-group-item kit-loading">
    <div class="row">
      Loading new kit   
    </div>
  </li>
</template>

<script>
export default {
  name: 'loadingKitItem'
}
</script>



// WEBPACK FOOTER //
// src/components/elements/LoadingKitItem.vue